import type { ISize } from '@ipfabric/utils/elements/types';
import type { TableCommandFactory } from 'components/Table/model/TableModel';

interface SetTableContainerSizeCommand {
  size: ISize;
}

export const setTableContainerSize: TableCommandFactory<
  SetTableContainerSizeCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.tableContainerSize = command.size;
  });
};
